import BlogPostsContainer from "./BlogPostsContainer";

export default BlogPostsContainer;